/**
 * Node types that are not supported for running models
 * These nodes will show an error message when selected for running
 */
export const UNSUPPORTED_NODE_TYPES = ['painter', 'masks', 'deprecated'] as const;

/**
 * Node types that should be ignored when running selected nodes
 * These nodes will be silently filtered out from the selection
 */
export const IGNORE_NODE_TYPES = ['stickynote', 'custom_group'] as const;

export const ITERATOR_NODE_TYPES = ['muxv2', 'media_iterator'] as const;

export const PROMPT_NODE_ID = 'jzXJ8QEfxQm2sZfvzu7q';

export const IMPORT_NODE_DEFINITION_ID = 'wkKkBSd0yrZGwbStnU6rClone';

export const IMPORT_MODEL_NODE_ID = 'RGDNWgeo7rDYAhTlOtXD';
